<!-- 任务卡片组件 -->
<template>
  <div>
    <div class="chat-card" @click="selectCard(item)" v-for="(item, index) in cardList" :key="index">
      <div class="chat-text">
        <div class="answer-title">{{ item.title }}</div>
        <div class="answer-tips">{{ item.tips }}</div>
      </div>
      <div class="chat-img" :style="`width: ${item.width || '56'}px`">
        <img class="img" :src="item.imgUrl" alt="">
      </div>
    </div>
    <!-- <div class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>
export default {
  name: 'ChatAnswerSheet',
  components: {
  },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      cardList: [
        {
          title: '和biubiu聊天',
          tips: '点击和biubiu聊天',
          imgUrl: require('@/assets/images/automatedThinkingAI-icon.png'),
          is_llm: true,
        },
        {
          title: '自助填写',
          tips: '点击进入自动化思维自助填写',
          imgUrl: require('@/assets/images/automatedMindRecognitionDetails-icon.png'),
          hrefUrl: '/automatedMindRecognitionDetails',
          is_llm: false,
        },
      ]
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    selectCard(item) {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          current: {
            is_llm: item.is_llm
          }
        },
      };
      this.$emit('confirmFn', useData);
      if(!item.is_llm) {
        this.$router.replace({
          path: `${item.hrefUrl}?id=${this.cardData.id}`
        })
      }
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 290px;
  height: 67px;
  border-radius: 12px 12px 12px 0px;
  padding: 0 13px 0 19px;
  background: #EDF4FC;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;
  .chat-text {
    .answer-title {
      font-size: 16px;
      font-weight: 400;
      color: $text-color;
    }
    .answer-tips {
      font-size: 9px;
      font-weight: 400;
      margin-top: 5px;
      color: #a6a6a6;
    }
  }
  .chat-img {
    height: 56px;
    .img {
      height: 100%;
    }
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
</style>
